import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@pushpress/pushpress-ui";

type ConfirmationModalProps = {
  open: boolean;
  onOpenChange: () => void;
  title: string;
  content: string;
  onClose: () => void;
  onConfirm: () => void;
  confirmationButtonText: string;
  isLoading?: boolean;
};

export default function ConfirmationModal({
  open,
  onOpenChange,
  title,
  content,
  onClose,
  onConfirm,
  confirmationButtonText,
  isLoading,
}: ConfirmationModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        {content}
        <DialogFooter>
          <Button variant="outline" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="default"
            size="sm"
            onClick={onConfirm}
            isSubmitting={isLoading}
            disabled={isLoading}
          >
            {confirmationButtonText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
